/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Availability } from './';
import {
    AvailabilityFromJSON,
    AvailabilityFromJSONTyped,
    AvailabilityToJSON,
} from './';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';
import type { WorkConditions } from './';
import {
    WorkConditionsFromJSON,
    WorkConditionsFromJSONTyped,
    WorkConditionsToJSON,
} from './';
import type { WorkingStatus } from './';
import {
    WorkingStatusFromJSON,
    WorkingStatusFromJSONTyped,
    WorkingStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface OnSite
 */
export interface OnSite extends WorkConditions {
    /**
     * 
     * @type {PostalAddress}
     * @memberof OnSite
     */
    address: PostalAddress;
}

/**
 * Check if a given object implements the OnSite interface.
 */
export function instanceOfOnSite(value: object): value is OnSite {
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function OnSiteFromJSON(json: any): OnSite {
    return OnSiteFromJSONTyped(json, false);
}

export function OnSiteFromJSONTyped(json: any, ignoreDiscriminator: boolean): OnSite {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...WorkConditionsFromJSONTyped(json, ignoreDiscriminator),
        'address': PostalAddressFromJSON(json['address']),
    };
}

export function OnSiteToJSON(value?: OnSite | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...WorkConditionsToJSON(value, true),
        'address': PostalAddressToJSON(value['address']),
    };
}

